<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Yvz1KW/images/cover.jpg?1704638987093" alt="This image is the cover for the book Great Central Railway"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Great Central Railway
      </h1>
      <p class="bookDescription body article font2">
        <b>“Sets out to address what really happened . . . through its LNER days and into British Railways custodianship . . . A well-researched and presented tome.” —<i>Key Model World</i></b><br/><br/>For generations of railway enthusiasts and more lately for social historians, the life and times of the former Great Central Railway and in particular its extension towards London in the 1890s and closure seventy years later, have generated considerable interest and controversy.<br/><br/>Although many books have been written about the Railway, the majority in recent times have concentrated upon providing a photographic record and a nostalgic look in retrospect to what was generally perceived as happier times for the route.<br/><br/>None of the books have presented the outcome from thorough research into the business aspects of the Railway and its successive private (LNER) and public (BR) ownerships through war and peace, and times of industrial, social and political change, that influenced and shaped the demand for a railway service.<br/><br/>While retaining a strong railway theme throughout, the book identifies the role played by successive governments, the electricity and coal industries and the effect of social change that, together resulted in a case for closure.<br/><br/>The content of the book replaces much supposition with fact and places on record what really happened.<br/><br/>The final part of the book acknowledges the fine work over half a century of volunteers dedicated to saving a section of the line in Leicestershire.<br/><br/><b>“A valuable addition to the social and political history of railways.” —The Railway Correspondence and Travel Society</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Palmer
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword Transport
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?573bc399